import { PLATFORM_CONFIGS, POST_TYPE } from '../constants';
import type { TransformedContent, Post } from '../types';

export function createTransformedContent(post: Post): TransformedContent {
  const { platform, text, attachments = [], pageName, username } = post;
  const config = PLATFORM_CONFIGS[platform];

  // Separate attachments by type
  const imageAttachments = attachments.filter(a => a.type === 'image');
  const videoAttachments = attachments.filter(a => a.type === 'video');

  // Determine post type
  let postType: number = POST_TYPE.COMMENT;
  if (videoAttachments.length > 0) {
    postType = POST_TYPE.VIDEO;
  } else if (imageAttachments.length > 0) {
    postType = POST_TYPE.GALLERY;
  }

  // Build image cards
  const imageCards = imageAttachments.map((attachment, index) => ({
    url: '',
    title: '',
    description: '',
    caption: '',
    call_to_action: null,
    medium: {
      id: index + 1,
      type: 'image',
      sizes: {
        original: { src: attachment.url, width: 1200, height: 630 },
        lightbox: { src: attachment.url, width: 1200, height: 630 },
        thumb: { src: attachment.url, width: 360, height: 240 },
      },
      meta: {
        is_animated_gif: false,
        is_panorama: false,
        is_spherical: false,
      },
    },
  }));

  // Build video cards
  const videoCards = videoAttachments.map((attachment, index) => ({
    url: '',
    title: '',
    description: '',
    caption: '',
    call_to_action: null,
    medium: {
      id: 900 + index,
      type: 'video',
      sizes: {
        medium: { src: attachment.url, width: 1280, height: 720 },
      },
      original_thumb: null,
      custom_thumb: null,
      meta: {
        duration: 0,
        mime_type: 'video/mp4',
        file_size: 0,
      },
      status: 3,
    },
  }));

  return {
    id: 1,
    date: new Date().toISOString().split('T')[0],
    time: new Date().toTimeString().split(' ')[0],
    type: postType,
    subtype: 0,
    text: text,
    page: {
      id: 1,
      type: config.pageType,
      name: pageName || config.defaultPageName,
      username: username || '',
      logo_src: null,
      followers: null,
    },
    attachments: {
      cards: [...imageCards, ...videoCards],
      multi_share_end_card: false,
    },
  };
}
